import PropTypes from 'prop-types';
import React from 'react'; // eslint-disable-line no-unused-vars

const { arrayOf, bool, number, objectOf, oneOfType, shape, string } = PropTypes; // eslint-disable-line no-unused-vars

export default shape({
  createdBy: string,
  createdDate: string,
  isArchived: bool,
  isGroup: bool,
  members: arrayOf(string),
  nickname: string,
  teamName: string,
  userID: string,
  userKey: string,
  username: string
});



// WEBPACK FOOTER //
// ./js/types/api/group.js